import { GrayColors } from "@smartsuite/types";
import styled from "styled-components";

export const RefreshFooterContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 4px;
  border-top: 1px solid #0000001a;
`;

export const RefreshButton = styled.button`
  display: flex;
  align-items: flex-start;
  padding: 6px 6px;
  border-radius: 4px;
  gap: 8px;
  background: none;
  border: none;
  width: 100%;

  &:hover {
    background: ${GrayColors["G-1"]};
    transition: background 0.2s ease-in-out;

    svg {
      transform: rotate(180deg);
      transition: transform 0.25s ease-in-out;
    }
  }
`;
